import React from "react";
import { Card } from "./card/card";
import { PillModeContent } from "../pillmodeContent";

export const MODES: {
  icon: string;
  name: string;
  title: string;
  mode: "blue" | "red";
  buttonText: string;
  points: string[];
  ButtonLabels: string[];
  checkBg: string;
  borderColor: string;
  button?: string;
}[] = [
  {
    icon: "/assets/blue_pill.png",
    name: "Builder Mode",
    title: "Builder Mode (Blue Pill)",
    mode: "blue",
    buttonText: "Build Smart",
    points: [
      "Reputation-based investing with wallet verification",
      "Anti-bot mechanics including vesting schedules and liquidity protection",
      "Flexible launch settings for full control over participation and token distribution",
      "Designed for long-term sustainability and growth",
    ],
    ButtonLabels : [
      "Full Control Over Tokenomics",
      "Advanced Features for you",
      "Secure, Scalable, Long-Term Strategy",
    ],
    checkBg: "bg-[#132345]",
    borderColor: "border-[#132345]",
    button: "bg-gradient-blue-dark",
  },
  {
    icon: "/assets/red_pill.png",
    name: "Degen Mode",
    title: "Degen Mode (Red Pill)",
    mode: "red",
    buttonText: "Launch Now",
    points: [
      "Instant token creation with no restrictions",
      "Open-market trading, no trust scores or additional verification required",
      "Focused on speculative opportunities and fast liquidity",
      "Designed for rapid market entry with high-risk, high-reward potential",
    ],
    ButtonLabels : [
      "Quick Token Launch, No Hassle",
      "Fast, Simple, No Restrictions",
      "Instant Deployment, Minimal Setup",
    ],
    checkBg: "bg-[#39141A]",
    button: "bg-gradient-red-dark",
    borderColor: "border-[#39141A]",
  },
];

export default function LaunchingCards() {
  return (
    <div className="flex items-center w-full xl:flex-row flex-col gap-8 my-3">
      {MODES.map((item) => (
        <Card
          key={item.mode}
          className="w-auto"
          botttomGrid
          blob
          blobPosition="top-0 right-0"
          pillMode={item.mode}
        >
          <PillModeContent
            icon={item.icon}
            title={item.title}
            mode={item.mode}
            points={item.points}
            buttonText={item.buttonText}
          />
        </Card>
      ))}
    </div>
  );
}
